import { UpdateUserRequest } from '@/api/users/request.types.ts'
import { UpdateUserResponse } from '@/api/users/response.types.ts'
import { useUsersApiClient } from '@/api/users/useUsersApiClient.ts'
import { useUpdateItem } from '@/presentation/common/hooks/crud/v2/useUpdateItem.ts'

export const useUpdateUser = () => {
  const repository = useUsersApiClient()
  const updateItem = useUpdateItem<UpdateUserRequest, UpdateUserResponse>({
    callable : repository.update,
    messages : {
      default       : 'No se pudo actualizar el usuario',
      alreadyExists : 'Ya existe un usuario con el mismo usuario',
      success       : 'Usuario actualizado con éxito',
      loading       : 'Actualizando usuario',
    },
  })

  return {
    ...updateItem,
  }
}
